import { render, staticRenderFns } from "./CardScaffoldDocuments.vue?vue&type=template&id=8c0ccbea"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c0ccbea')) {
      api.createRecord('8c0ccbea', component.options)
    } else {
      api.reload('8c0ccbea', component.options)
    }
    module.hot.accept("./CardScaffoldDocuments.vue?vue&type=template&id=8c0ccbea", function () {
      api.rerender('8c0ccbea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/cards/CardScaffoldDocuments.vue"
export default component.exports